import React from 'react';
import { Link } from '../../routing';
import './AboutPage.scss';

const AboutPage: React.FC<{ menuOpen: boolean }> = ({ menuOpen }) => <div className={`about-page ${menuOpen ? 'menu-open' : ''}`}>
  <div className="about-page__background" style={{ backgroundImage: "linear-gradient(90deg, rgba(0,0,0,.84), rgba(0,0,0,.58) 65%, rgba(0,0,0,.76)), url('/images/Banner-Hero2.jpg')" }} />
  <div className="about-page__content">
    <p className="about-page__kicker">ABOUT STAGE DOOR MEDIA</p>
    <h1>Stories worth watching</h1>
    <p className="about-page__intro">We make films with a clear sense of place, pace and purpose. From aerial work and FPV to weddings, events and commercial projects, we bring a considered approach to every shoot.</p>
    <div className="about-page__panels">
      <article><h2>A considered approach</h2><p>Good films start with listening. We take time to understand what needs to be shown, who it is for and how it should feel.</p></article>
      <article><h2>Made to last</h2><p>We care about the details, from the first shot through to the final edit, creating films that remain useful long after the day they were made.</p></article>
    </div>
    <Link to="/contact" className="btn btn-accent">Start a conversation</Link>
  </div>
</div>;

export default AboutPage;
